// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"kS-z","categoryName":"lS-z","categoryNameSearchHeader":"mS-z","categoryContent":"nS-z","bottomAligned":"oS-z","image":"pS-z","imageNoBackground":"qS-z"};